export const ASSESSMENT_COMMON = {
  logoPath: '/assets/images/TLC-Logo.svg',
  logoAlt: 'TLC Logo',
  showTopDivider: true,
};
